export default __webpack_public_path__ + "static/media/fjarrtolkning2.1ffccf9f.png";